module.exports = __webpack_public_path__ + "img/home_fr19.415b0d79.png";